<div class="page-container page-containers content-w-98">
  <div class="page-head">
    <div>
      <div class="page-title">
        <span class="headerName">{{ headerData!.materialName }}</span>
      </div>
    </div>
  </div>
  <div [ngClass]="{ 'disabled-project': projectData?.isLockProject }">
    <div>
      <div class="row">
        <div
          class="col-md-12"
          *ngrxLet="{
            dataLoaded: (sharedFacade.isLoaded$ | async),
            isClearSearch: (sharedFacade.isClearSearch$ | async)
          } as sharedData"
        >
          <piqet-angular-portlet
            [columnDefs]="projectData?.isCostTurnOff ? columnDefs : costColumnDefs"
            [frameworkComponents]="frameworkComponents"
            [headerBtn]="'Add component detail'"
            [class]="'detail-cell-renderer fixedHeight'"
            [gridData]="projectData?.componentList"
            [hideSideBar]="isHideSideBar"
            [pageNo]="$any(projectData)?.draw"
            (openBtnModal)="addMatierialModal(scenarioId, 0, true, 'Add component details')"
            [searchInputSize]="true"
            (inlineDataEditEvent)="editRecord($event)"
            [isClearSearch]="sharedData.isClearSearch"
            [gridName]="gridName"
            [createAccess]="showEdit"
            [stepTitle]="'Add component'"
            [stepCount]="'step17'"
            (guidedTourPrevEvent)="onPrev('step17')"
            [stepText]="
              'Click here to start adding material component details and its associated conversion process.'
            "
            (guidedTourEvent)="moveToNextStep()"
             (changeRowOrder)="changeRowOrder($event)"
          ></piqet-angular-portlet>
        </div>
      </div>
    </div>
  </div>
  <piqet-angular-navigation-button [config]="navigationConfig"> </piqet-angular-navigation-button>
</div>
